import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";
import type { RouterContext } from "@/app/router/context";
import { NotFound } from "@/components/feedback/not-found";

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({ meta: [{ title: "Rogue AI" }] }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  notFoundComponent: () => <NotFound />,
});
